export default "__VITE_ASSET__e_9sNg9Z__"